module.exports = __webpack_public_path__ + "static/media/fullScreen.799b8177.svg";